<template>
  <el-dialog
    :visible.sync="showDialog"
    class="dialog-apply"
    :title="title"
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
  >
    <div class="dialog-content">
      <div class="content-close" @click="handleCloseDialog"><img src="@/assets/icon_close.png" /></div>
      <div class="content-title">升级会员</div>
      <div class="content-text">你已申请1个案例。若想申请演示更多案例， 请升级为专业版用户。</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="custom-button btn-e0e0e0" @click="handleCloseDialog"
        >取消</el-button
      >
      <el-button class="custom-button btn-determine current" @click="handleSubmit"
        >去升级</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import { Base64 } from "js-base64";
import { phoneValidator, timeLoop } from "@/assets/js/util";
export default {
  name: "ApplyFild",
  data() {
    return {
      showDialog: false,
      isRequesting: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  mounted() {
    let _this = this;
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let userInfo = _this.$store.state.user;
      return userInfo;
    }
  },
  methods: {
    handleCloseDialog: function () {
      let _this = this;
      if (_this.timerObj && _this.timerObj.timer) {
        clearTimeout(_this.timerObj.timer);
      }
      _this.showDialog = false;
    },
    handleSubmit: function () {
      let _this = this;
      _this.$router.push({path: '/memberintroduce'})
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-apply {
  /deep/.el-dialog {
    position: absolute;
    width: 500px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 100%;
      display: none;
      align-items: center;
      justify-content: space-between;
      padding: 30px 38px 40px;
      box-sizing: border-box;
      .el-dialog__title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
        text-align: left;
      }
      .el-dialog__headerbtn {
        position: relative;
        width: 16px;
        height: 16px;
        overflow: hidden;
        background: url("../../assets/icon_dialog_delete.png") no-repeat;
        background-size: 100% 100%;
        top: 0;
        right: 0;
        .el-dialog__close {
          &::before {
            content: none;
          }
        }
      }
    }
    .el-dialog__body {
      position: relative;
      width: 100%;
      height: 186px;
      box-sizing: border-box;
      overflow: auto;
      background: url(~@/assets/dialog_bg.png) no-repeat center;
      background-size: 100% 100%;

    }
  }
  /deep/.el-dialog__footer {
    position: relative;
    width: 100%;
    padding: 32px 0;
  }
  /deep/.dialog-footer {
    display: flex;
    justify-content: center;
    .custom-button {
      width: 80px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      margin-left: 25px;

      &.btn-determine.current {
        background-color: #EC4040;
        color: #FFFFFF;
      }

      &:first-child {
        margin-left: 0;
      }
    }
  }
  .dialog-content {
    position: relative;
    .content-close {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content-title {
      color: #EC4040;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 32px;
    }
    .content-text {
      font-size: 16px;
      padding: 0 32px;
      line-height: 2;
    }
  }
}
</style>
